/**
 * @generated SignedSource<<ca5bc49dc0cd963d7ce8787b6124caeb>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type VimeoVideo_videoVimeo$data = {
  readonly vimeoId: string | null;
  readonly " $fragmentType": "VimeoVideo_videoVimeo";
};
export type VimeoVideo_videoVimeo$key = {
  readonly " $data"?: VimeoVideo_videoVimeo$data;
  readonly " $fragmentSpreads": FragmentRefs<"VimeoVideo_videoVimeo">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "VimeoVideo_videoVimeo",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "vimeoId",
      "storageKey": null
    }
  ],
  "type": "VideoVimeo",
  "abstractKey": null
};

(node as any).hash = "95429ac5baa17e3072e9bbd094184b1b";

export default node;
